import { render } from "./SoundEffectConfig.vue?vue&type=template&id=20286b5e&scoped=true"
import script from "./SoundEffectConfig.vue?vue&type=script&lang=js"
export * from "./SoundEffectConfig.vue?vue&type=script&lang=js"

import "./SoundEffectConfig.vue?vue&type=style&index=0&id=20286b5e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20286b5e"]])

export default __exports__